export const SET_DASHBOARD_STATE = 'SET_DASHBOARD_STATE';